import { P2GText } from '@parcel2go/core-ui';
import { ItemActions, SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';
import { AsyncLinks } from '../actions/book/AsyncLinks';

interface props {
  item: SmartSendItemApiModel;
  actions: ItemActions;
}

const Labels = ({ actions, item }: props) => {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  return (
    <AsyncLinks
      title={t('DOWNLOAD_YOUR_LABEL_SUBTITLE', { defaultValue: 'Download Your Labels' })}
      variant="label"
      links={actions.Links}
      match={(x) => x.Type.startsWith('LABELS-')}
      tag={item?.BookingDetails?.Reference}
    >
      <P2GText variant="body2">
        {t('CHOOSE_LABEL_OPTIONS', {
          defaultValue: 'Choose one of the options here to download your label.'
        })}
      </P2GText>
    </AsyncLinks>
  );
};
export default Labels;
